import { Formik } from 'formik';
import { ErrorText, InputField, Text, RadioButton, Dropdown } from '../../../components/SecondaryMarket';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import ViewReverse from '../../../components/ViewReverse';
import {
  yes_no_options,
} from '../../../config/config';
import ViewItems from '../../../components/ViewItems';
import { cn, formatNumbers, getContentKeyAccToLang } from '../../../utils/utils';
import { ReactSVG } from 'react-svg';
import icons from '../../../constants/icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  client_classification_schema,
  client_classification_validation_schema,
} from '../../../validations_schemas/client_classification_validation_schema';
import { isEmptyValue, alphabet_regix, getRejectedFieldData, numeric_decimal_regix } from '../../../utils/functions';
import { setIsQualified } from '../../../store/slices/corporate-slice';

const ClientClassification = ({ isKYC, isOpen = true, setStep, contentKey, formRef, percentage }) => {
  const { TextWeight, isArabic } = dynamicfunction();
  const dispatch = useDispatch();

  const corpKycContent = useSelector((state) => state.content?.corpKycContent);
  const corpAOContent = useSelector((state) => state.content?.corpAOContent);
  const { corporate_dropdown_data, corporate_kyc_data, rejection_summary, field_codes } = useSelector((state) => state.corporate);
  const clientClasificationData = isKYC ? corporate_kyc_data?.kycClientClassification : corporate_kyc_data?.accountOpeningClientClassification
  const getContentKey = (key) => {
    const content = isKYC ? corpKycContent : corpAOContent;
    return getContentKeyAccToLang(content?.[contentKey]?.data?.attributes, key, isArabic);
  };

  const rejectedFields = rejection_summary?.find(item => item?.sectionId === 4)?.rejectedFields || [];
  const clientClassificationRejectedField = rejectedFields?.length < 1 ? null : getRejectedFieldData(rejectedFields, field_codes, 'clientClassificationId');
  const fieldWorkRejectedField = rejectedFields?.length < 1 ? null : getRejectedFieldData(rejectedFields, field_codes, 'doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities');
  const investmentKnowledgeRejectedField = rejectedFields?.length < 1 ? null : getRejectedFieldData(rejectedFields, field_codes, 'howYouEvaluateYourInvestmentKnowledgeAndExperience');
  const investmentFrequencyRejectedField = rejectedFields?.length < 1 ? null : getRejectedFieldData(rejectedFields, field_codes, 'howOftenHaveTheInstituionInvestedInFinancialSecurities');
  const majorityInvetmentRejectedField = rejectedFields?.length < 1 ? null : getRejectedFieldData(rejectedFields, field_codes, 'howHasTheInstitutionMadeTheseInvestments');
  const typeOfInvestmentRejectedField = rejectedFields?.length < 1 ? null : getRejectedFieldData(rejectedFields, field_codes, 'clientClassificationTypeOfInvestments');
  const marginTransactionRejectedField = rejectedFields?.length < 1 ? null : getRejectedFieldData(rejectedFields, field_codes, 'hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears');

  return (
    <div>
      <ViewReverse className={cn('w-full items-center gap-2 justify-between', isKYC && 'cursor-pointer')} onClick={() => isKYC && setStep(3)}>
        <ViewReverse className="flex items-center gap-2">
          <Text text={getContentKey('client_classification')} weight={TextWeight.headingRegular} className={'text-dark-blue'} size={fontSizes.h30} />
          {rejectedFields?.length > 0 && <ReactSVG src={icons.heading_info_outline_icon} />}
        </ViewReverse>

        <ViewReverse className={'items-center gap-2'}>
          <Text text={`${formatNumbers(percentage) ?? 0}%`} className={'text-dark-blue'} size={fontSizes.h14} />
          {isKYC && <ReactSVG src={icons.downArrow} className={cn(isOpen ? 'rotate-180' : 'rotate-0')} />}
        </ViewReverse>
      </ViewReverse>

      <Formik
        innerRef={formRef}
        validationSchema={client_classification_validation_schema}
        initialValues={client_classification_schema(clientClasificationData)}
        validateOnChange={false}
        validateOnMount={false}
        validateOnBlur={false}
        enableReinitialize
        onSubmit={(values) => { }}
      >
        {({ values, setFieldValue, errors, setFieldError }) => {

          return (
            isOpen && (
              <>
                <div className='mt-7 mb-9 h-[1px] bg-black/10' />

                <ViewItems className={'gap-1'}>
                  <Text text={getContentKey('general_information')} className={'text-light-blue'} size={fontSizes.h22} />
                  <Text
                    text={getContentKey('general_information_info')}
                    className={'text-dark-grey/50'}
                    size={fontSizes.h12}
                  />
                </ViewItems>

                <Text text={getContentKey('client_classification_label')} isEmpty={isEmptyValue(values?.clientClassificationId)} className={'text-primary-light mt-8'} size={fontSizes.h14} isRequired />
                <ViewReverse className={'gap-2 md:gap-6 mt-2'} isResponsive>
                  {corporate_dropdown_data?.clientClassificationTypeOfInvestments?.map((item) => (
                    <ViewItems className={'w-full'} key={item?.id}>
                      <RadioButton
                        label={item?.name}
                        selected={values?.clientClassificationId === item?.id}
                        className={'items-start'}
                        onClick={() => {
                          if (values?.clientClassificationId === item?.id) {
                            setFieldValue('clientClassificationId', null);
                            dispatch(setIsQualified(false));
                          } else {
                            setFieldValue('clientClassificationId', item?.id);
                            dispatch(setIsQualified(item?.id === 1070));
                          }
                        }}
                        subText={item?.description}
                        subTextColor={'text-dark-grey/50'}
                        subTextSize={fontSizes.h14}
                        remarksMetadata={values?.clientClassificationId !== clientClasificationData?.clientClassification ? null : {
                          sectionId: 4,
                          key: 'clientClassificationId',
                        }}
                      />
                    </ViewItems>
                  ))}
                </ViewReverse>
                {
                  clientClassificationRejectedField?.remarks?.length > 0 && (values?.clientClassificationId === clientClasificationData?.clientClassification) && (
                    <ViewReverse className='items-center gap-2 mt-2'>
                      <ReactSVG src={icons.field_info_outline} />
                      <ErrorText text={clientClassificationRejectedField?.remarks} className={'mt-0'} />
                    </ViewReverse>
                  )
                }
                <ErrorText text={getContentKey(errors?.clientClassificationId)} />

                {String(values?.clientClassificationId) === '1069' && (
                  <ViewItems className='gap-4 mt-8'>
                    <Text
                      text={getContentKey('institutional_investor_criteria')} isEmpty={isEmptyValue(values?.ifInstitutionalInvestorSelectOneOfTheFollowingCriteria)}
                      size={fontSizes.h14}
                      className='text-primary-light'
                      isRequired
                    />

                    {corporate_dropdown_data?.institutionalInvestorCriteria?.map((item, index) => (
                      <div key={item?.id} className='flex flex-col gap-1'>
                        <RadioButton
                          label={item?.name}
                          selected={values?.ifInstitutionalInvestorSelectOneOfTheFollowingCriteria === item?.id}
                          onClick={() => {
                            if (values?.ifInstitutionalInvestorSelectOneOfTheFollowingCriteria === item?.id) {
                              setFieldValue('ifInstitutionalInvestorSelectOneOfTheFollowingCriteria', null);
                            } else {
                              setFieldValue('ifInstitutionalInvestorSelectOneOfTheFollowingCriteria', item?.id)
                            }
                            setFieldError('ifInstitutionalInvestorSelectOneOfTheFollowingCriteria', null);
                          }}
                          className='items-start'
                          subText={item?.description}
                          isShowRemarks={corporate_dropdown_data?.institutionalInvestorCriteria?.length === index + 1}
                          remarksMetadata={
                            !(clientClassificationRejectedField?.remarks?.length > 0) &&
                            (values?.ifInstitutionalInvestorSelectOneOfTheFollowingCriteria === clientClasificationData?.ifInstitutionalInvestorSelectOneOfTheFollowingCriteria) && {
                              sectionId: 4,
                              key: 'ifInstitutionalInvestorSelectOneOfTheFollowingCriteria',
                            }}
                        />
                      </div>
                    ))}
                    <ErrorText text={getContentKey(errors?.ifInstitutionalInvestorSelectOneOfTheFollowingCriteria)} />
                  </ViewItems>
                )}

                {String(values?.clientClassificationId) === '1070' && (
                  <ViewItems className='gap-4 mt-8'>
                    <Text
                      text={getContentKey('qualified_investor_criteria')} isEmpty={isEmptyValue(values?.ifQualifiedInvestorSelectOneOfTheFollowingCriteria)}
                      size={fontSizes.h14}
                      className='text-primary-light'
                      isRequired
                    />

                    {corporate_dropdown_data?.qualifiedInvestorCriteria?.map((item) => (
                      <div key={item?.id} className='flex flex-col gap-1'>
                        <RadioButton
                          label={item?.name}
                          selected={values?.ifQualifiedInvestorSelectOneOfTheFollowingCriteria === item?.id}
                          onClick={() => {
                            if (values?.ifQualifiedInvestorSelectOneOfTheFollowingCriteria === item?.id) {
                              setFieldValue('ifQualifiedInvestorSelectOneOfTheFollowingCriteria', null);
                            } else {
                              setFieldValue('ifQualifiedInvestorSelectOneOfTheFollowingCriteria', item?.id)
                            }
                            setFieldError('ifQualifiedInvestorSelectOneOfTheFollowingCriteria', null);
                          }}
                          className='items-start'
                          subText={item?.description}
                          remarksMetadata={
                            !(clientClassificationRejectedField?.remarks?.length > 0) &&
                            (values?.ifQualifiedInvestorSelectOneOfTheFollowingCriteria === clientClasificationData?.ifQualifiedInvestorSelectOneOfTheFollowingCriteria) && {
                              sectionId: 4,
                              key: 'ifQualifiedInvestorSelectOneOfTheFollowingCriteria',
                            }}
                        />
                      </div>
                    ))}
                    <ErrorText text={getContentKey(errors?.ifQualifiedInvestorSelectOneOfTheFollowingCriteria)} />
                  </ViewItems>
                )}

                <ViewReverse className={'gap-6 mt-10 flex-1'} isResponsive>
                  <InputField
                    label={getContentKey('source_of_fund')}
                    isRequired
                    placeholder={getContentKey('enter_source_of_fund')}
                    value={values?.whatIsTheSourceOfFundsForThisAccount}
                    maxLength={50}
                    onChange={(text) => {
                      if (alphabet_regix.test(text)) {
                        setFieldValue('whatIsTheSourceOfFundsForThisAccount', text)
                      }
                    }
                    }
                    isLabelHeight
                    isArabicAllowed
                    labelDivClass={'md:h-8 lg:h-8'}
                    error={getContentKey(errors?.whatIsTheSourceOfFundsForThisAccount)}
                    remarksMetadata={values?.whatIsTheSourceOfFundsForThisAccount !== clientClasificationData?.whatIsTheSourceOfFundsForThisAccount ? null : {
                      sectionId: 4,
                      key: 'whatIsTheSourceOfFundsForThisAccount',
                    }}
                  />

                  <ViewItems className='gap-3 w-full'>
                    <Text text={getContentKey('current_location_of_funds')} isEmpty={isEmptyValue(values?.classificationFundCurrentLocations)} size={fontSizes.h14} className='text-primary-light' isRequired />
                    {corporate_dropdown_data?.currentLocationOfFund?.map((item, index) => (
                      <RadioButton
                        key={index}
                        label={item?.name}
                        selected={values?.classificationFundCurrentLocations?.find((loc) => loc?.valueId === item?.id)}
                        onClick={() => {
                          const exist = values?.classificationFundCurrentLocations?.find((loc) => loc?.valueId === item?.id);

                          if (exist) {
                            setFieldValue(
                              'classificationFundCurrentLocations',
                              values?.classificationFundCurrentLocations?.filter((loc) => loc?.valueId !== item?.id),
                            );
                          } else {
                            setFieldValue('classificationFundCurrentLocations', [...values?.classificationFundCurrentLocations, { valueId: item?.id }]);
                          }
                          setFieldError('classificationFundCurrentLocations', null);
                        }}
                        isSquare
                        isShowRemarks={corporate_dropdown_data?.currentLocationOfFund?.length === index + 1}
                        className='items-start'
                        remarksMetadata={values?.classificationFundCurrentLocations?.join('') === clientClasificationData?.classificationFundCurrentLocationViewResponses?.join('') && {
                          sectionId: 4,
                          key: 'classificationFundCurrentLocations',
                        }}
                      />
                    ))}
                    <ErrorText text={getContentKey(errors?.classificationFundCurrentLocations)} />
                  </ViewItems>

                  <ViewItems className='gap-3 w-full'>
                    <Text
                      text={getContentKey('institution_relate_to_financial_securities')} isEmpty={isEmptyValue(values?.doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities)}
                      size={fontSizes.h14}
                      className='text-primary-light'
                      isRequired
                    />

                    <ViewReverse className={'gap-6'}>
                      {yes_no_options?.map((item) => (
                        <RadioButton
                          key={item?.id}
                          label={getContentKey(item?.name)}
                          selected={values?.doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities === item?.value}
                          onClick={() => {
                            if (values?.doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities === item?.value) {
                              setFieldValue('doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities', null);
                            } else {
                              setFieldValue('doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities', item?.value)
                            }
                            setFieldError('doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities', null);
                          }}
                          remarksMetadata={values?.doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities !== clientClasificationData?.doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities ? null : {
                            sectionId: 4,
                            key: 'doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities',
                          }}
                        />
                      ))}
                    </ViewReverse>
                    {
                      fieldWorkRejectedField?.remarks?.length > 0 && values?.doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities === clientClasificationData?.doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities && (
                        <ViewReverse className='items-center gap-2 mt-2'>
                          <ReactSVG src={icons.field_info_outline} />
                          <ErrorText text={fieldWorkRejectedField?.remarks} className={'mt-0'} />
                        </ViewReverse>
                      )
                    }
                  </ViewItems>
                </ViewReverse>

                <div className='my-10 h-[1px] bg-black/10' />

                <Text text={getContentKey('financial_experience')} className={'text-light-blue'} size={fontSizes.h22} />

                <Text
                  text={getContentKey('investment_knowledge_experience')} isEmpty={isEmptyValue(values?.howYouEvaluateYourInvestmentKnowledgeAndExperience)}
                  className={'text-primary-light mt-8'}
                  size={fontSizes.h14}
                  isRequired
                />

                <ViewReverse className={'gap-3 md:gap-6 mt-3'} isResponsive>
                  {corporate_dropdown_data?.investmentKnowledgeAndExperience?.map((item) => (
                    <RadioButton
                      key={item?.id}
                      label={item?.name}
                      selected={values?.howYouEvaluateYourInvestmentKnowledgeAndExperience === item?.id}
                      onClick={() => {
                        if (values?.howYouEvaluateYourInvestmentKnowledgeAndExperience === item?.id) {
                          setFieldValue('howYouEvaluateYourInvestmentKnowledgeAndExperience', null);
                        } else {
                          setFieldValue('howYouEvaluateYourInvestmentKnowledgeAndExperience', item?.id)
                        }
                        setFieldError('howYouEvaluateYourInvestmentKnowledgeAndExperience', null);
                      }}
                      remarksMetadata={values?.howYouEvaluateYourInvestmentKnowledgeAndExperience !== clientClasificationData?.howYouEvaluateYourInvestmentKnowledgeAndExperience ? null : {
                        sectionId: 4,
                        key: 'howYouEvaluateYourInvestmentKnowledgeAndExperience',
                      }}
                    />
                  ))}
                </ViewReverse>
                {
                  investmentKnowledgeRejectedField?.remarks?.length > 0 && values?.howYouEvaluateYourInvestmentKnowledgeAndExperience === clientClasificationData?.howYouEvaluateYourInvestmentKnowledgeAndExperience && (
                    <ViewReverse className='items-center gap-2 mt-2'>
                      <ReactSVG src={icons.field_info_outline} />
                      <ErrorText text={investmentKnowledgeRejectedField?.remarks} className={'mt-0'} />
                    </ViewReverse>
                  )
                }
                <ErrorText text={getContentKey(errors?.howYouEvaluateYourInvestmentKnowledgeAndExperience)} />

                <Text
                  text={getContentKey('institution_invested_in_financial_securities')} isEmpty={isEmptyValue(values?.howOftenHaveTheInstituionInvestedInFinancialSecurities)}
                  className={'text-primary-light mt-8'}
                  size={fontSizes.h14}
                  isRequired
                />

                <ViewReverse className={'gap-2 md:gap-6 mt-3'} isResponsive>
                  {corporate_dropdown_data?.financialSecurities?.map((item) => (
                    <RadioButton
                      key={item?.id}
                      label={item?.name}
                      selected={values?.howOftenHaveTheInstituionInvestedInFinancialSecurities === item?.id}
                      onClick={() => {
                        if (values?.howOftenHaveTheInstituionInvestedInFinancialSecurities === item?.id) {
                          setFieldValue('howOftenHaveTheInstituionInvestedInFinancialSecurities', null);
                        } else {
                          setFieldValue('howOftenHaveTheInstituionInvestedInFinancialSecurities', item?.id)
                        }
                        setFieldError('howOftenHaveTheInstituionInvestedInFinancialSecurities', null);
                      }}
                      remarksMetadata={values?.howOftenHaveTheInstituionInvestedInFinancialSecurities !== clientClasificationData?.howOftenHaveTheInstituionInvestedInFinancialSecurities ? null : {
                        sectionId: 4,
                        key: 'howOftenHaveTheInstituionInvestedInFinancialSecurities',
                      }}
                    />
                  ))}
                </ViewReverse>
                {
                  investmentFrequencyRejectedField?.remarks?.length > 0 && values?.howOftenHaveTheInstituionInvestedInFinancialSecurities === clientClasificationData?.howOftenHaveTheInstituionInvestedInFinancialSecurities && (
                    <ViewReverse className='items-center gap-2 mt-2'>
                      <ReactSVG src={icons.field_info_outline} />
                      <ErrorText text={investmentFrequencyRejectedField?.remarks} className={'mt-0'} />
                    </ViewReverse>
                  )
                }
                <ErrorText text={getContentKey(errors?.howOftenHaveTheInstituionInvestedInFinancialSecurities)} />

                <ViewReverse className={'gap-6 mt-8 w-full'} isResponsive>
                  <Dropdown
                    label={getContentKey('total_volume_of_transactions')}
                    valueKey={'name'}
                    isRequired
                    value={values?.estimateTotaVolumeOfThoseTransactionsInSAR ? corporate_dropdown_data?.transactionVolumeInSAR?.find((v) => v?.id === values?.estimateTotaVolumeOfThoseTransactionsInSAR) : null}
                    options={corporate_dropdown_data?.transactionVolumeInSAR}
                    onSelect={(val) => setFieldValue('estimateTotaVolumeOfThoseTransactionsInSAR', val?.id)}
                    isLabelHeight
                    labelDivClass={'md:h-8'}
                    remarksMetadata={values?.estimateTotaVolumeOfThoseTransactionsInSAR !== clientClasificationData?.estimateTotaVolumeOfThoseTransactionsInSAR ? null : {
                      sectionId: 4,
                      key: 'estimateTotaVolumeOfThoseTransactionsInSAR',
                    }}
                  />
                  <ViewItems className='gap-3 w-full'>
                    <Text
                      text={getContentKey('how_institution_made_investments')} isEmpty={isEmptyValue(values?.howHasTheInstitutionMadeTheseInvestments)}
                      size={fontSizes.h14}
                      className='text-primary-light leading-4'
                      isRequired
                    />
                    <ViewReverse className={'gap-6 mt-3'}>
                      {corporate_dropdown_data?.howHaveYouMadeTheMajorityOfTheseInvestments?.map((item) => (
                        <RadioButton
                          key={item?.id}
                          label={item?.name}
                          selected={values?.howHasTheInstitutionMadeTheseInvestments === item?.id}
                          onClick={() => {
                            if (values?.howHasTheInstitutionMadeTheseInvestments === item?.id) {
                              setFieldValue('howHasTheInstitutionMadeTheseInvestments', null);
                            } else {
                              setFieldValue('howHasTheInstitutionMadeTheseInvestments', item?.id)
                            }
                            setFieldError('howHasTheInstitutionMadeTheseInvestments', null);
                          }}
                          remarksMetadata={values?.howHasTheInstitutionMadeTheseInvestments !== clientClasificationData?.howHasTheInstitutionMadeTheseInvestments ? null : {
                            sectionId: 4,
                            key: 'howHasTheInstitutionMadeTheseInvestments',
                          }}
                        />
                      ))}
                    </ViewReverse>
                    {
                      majorityInvetmentRejectedField?.remarks?.length > 0 && values?.howHasTheInstitutionMadeTheseInvestments === clientClasificationData?.howHasTheInstitutionMadeTheseInvestments && (
                        <ViewReverse className='items-center gap-2 mt-2'>
                          <ReactSVG src={icons.field_info_outline} />
                          <ErrorText text={majorityInvetmentRejectedField?.remarks} className={'mt-0'} />
                        </ViewReverse>
                      )
                    }
                    <ErrorText text={getContentKey(errors?.howHasTheInstitutionMadeTheseInvestments)} />
                  </ViewItems>

                  <Dropdown
                    label={getContentKey('years_in_financial_securities')}
                    valueKey={'name'}
                    value={values?.forHowManyYearsHasTheInstitutionInvestedInFinancialSecurities ? corporate_dropdown_data?.forHowManyYearsHaveYouInvestedInFinancialSecurities?.find((v) => v?.id === values?.forHowManyYearsHasTheInstitutionInvestedInFinancialSecurities) : null}
                    isRequired={false}
                    options={corporate_dropdown_data?.forHowManyYearsHaveYouInvestedInFinancialSecurities}
                    onSelect={(val) => setFieldValue('forHowManyYearsHasTheInstitutionInvestedInFinancialSecurities', val?.id)}
                    isLabelHeight
                    labelDivClass={'md:h-8'}
                    remarksMetadata={values?.forHowManyYearsHasTheInstitutionInvestedInFinancialSecurities !== clientClasificationData?.forHowManyYearsHasTheInstitutionInvestedInFinancialSecurities ? null : {
                      sectionId: 4,
                      key: 'forHowManyYearsHasTheInstitutionInvestedInFinancialSecurities',
                    }}
                  />
                </ViewReverse>

                <Text
                  text={getContentKey('type_of_investments')} isEmpty={isEmptyValue(values?.clientClassificationTypeOfInvestments)}
                  className='text-primary-light mt-10'
                  size={fontSizes.h14}
                  isRequired
                />

                <div className='grid grid-cols-1 md:grid-cols-4 gap-x-2 md:gap-x-6 mt-2' dir={isArabic ? 'rtl' : 'ltr'}>
                  {corporate_dropdown_data?.whatTypesOfInvestmentsHaveYouMadeInThePast?.flatMap((item, index) => {
                    const elements = [
                      <ViewReverse
                        key={item?.id}
                        className={cn('items-center gap-3 w-full', index + 1 === corporate_dropdown_data?.whatTypesOfInvestmentsHaveYouMadeInThePast?.length && 'md:col-span-2')}
                        isReverse={false}
                      >
                        <RadioButton
                          label={item?.name}
                          selected={values?.clientClassificationTypeOfInvestments?.find((loc) => loc?.valueId === item?.id)}
                          className='py-2.5'
                          isSquare
                          isReverse={false}
                          labelClasses='lg:truncate'
                          onClick={() => {
                            const exist = values?.clientClassificationTypeOfInvestments?.find((loc) => loc?.valueId === item?.id);

                            if (exist) {
                              setFieldValue(
                                'clientClassificationTypeOfInvestments',
                                values?.clientClassificationTypeOfInvestments?.filter((loc) => loc?.valueId !== item?.id),
                              );
                            } else {
                              setFieldValue('clientClassificationTypeOfInvestments', [...values?.clientClassificationTypeOfInvestments, { valueId: item?.id }]);
                            }
                          }}
                          remarksMetadata={values?.clientClassificationTypeOfInvestments?.join('') === clientClasificationData?.clientClassificationTypeOfInvestments?.join('') && {
                            sectionId: 4,
                            key: 'clientClassificationTypeOfInvestments',
                          }}
                        />

                        {item?.id === 1082 && values?.clientClassificationTypeOfInvestments?.find(item => item?.valueId === 1082) && (
                          <InputField
                            isRequired
                            isArabicAllowed
                            placeholder={getContentKey('enter_here')}
                            value={values?.clientClassificationTypeOfInvestments?.find(item => item?.valueId === 1082)?.otherTypeOfInvestment}
                            onChange={(text) => {
                              const updatedInvestments = values?.clientClassificationTypeOfInvestments?.map((inv) => {
                                if (inv?.valueId === 1082) {
                                  return { ...inv, otherTypeOfInvestment: text };
                                }
                                return inv;
                              });
                              setFieldValue('clientClassificationTypeOfInvestments', updatedInvestments);
                            }}
                            remarksMetadata={values?.clientClassificationTypeOfInvestments?.join('') === clientClasificationData?.clientClassificationTypeOfInvestments?.join('') && {
                              sectionId: 4,
                              key: 'clientClassificationTypeOfInvestments',
                            }}
                          />
                        )}
                      </ViewReverse>
                    ];

                    // After every 3rd item add empty column
                    if ((index + 1) % 3 === 0) {
                      elements.push(<div key={`empty-${index}`} className='hidden md:block' />);
                    }

                    return elements;
                  })}
                </div>
                {
                  typeOfInvestmentRejectedField?.remarks?.length > 0 && values?.clientClassificationTypeOfInvestments === clientClasificationData?.clientClassificationTypeOfInvestments && (
                    <ViewReverse className='items-center gap-2 mt-2'>
                      <ReactSVG src={icons.field_info_outline} />
                      <ErrorText text={typeOfInvestmentRejectedField?.remarks} className={'mt-0'} />
                    </ViewReverse>
                  )
                }
                <ErrorText text={getContentKey(errors?.clientClassificationTypeOfInvestments?.[0]?.valueId)} />

                <Text
                  text={getContentKey('any_margin_transactions')} isEmpty={isEmptyValue(values?.hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears)}
                  className={'text-primary-light mt-10'}
                  size={fontSizes.h14}
                  isRequired
                />

                <ViewReverse className={'gap-2 md:gap-6 mt-3'}>
                  {yes_no_options?.map((item) => (
                    <RadioButton
                      key={item?.id}
                      label={getContentKey(item?.name)}
                      selected={values?.hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears === item?.value}
                      onClick={() => {
                        if (values?.hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears === item?.value) {
                          setFieldValue('hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears', null);
                        } else {
                          setFieldValue('hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears', item?.value)
                        }
                        setFieldError('hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears', null)
                      }}
                      remarksMetadata={values?.hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears !== clientClasificationData?.hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears ? null : {
                        sectionId: 4,
                        key: 'hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears',
                      }}
                    />
                  ))}
                </ViewReverse>
                {
                  marginTransactionRejectedField?.remarks?.length > 0 && values?.hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears === clientClasificationData?.hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears && (
                    <ViewReverse className='items-center gap-2 mt-2'>
                      <ReactSVG src={icons.field_info_outline} />
                      <ErrorText text={marginTransactionRejectedField?.remarks} className={'mt-0'} />
                    </ViewReverse>
                  )
                }

                {
                  values?.hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears && (
                    <InputField
                      label={getContentKey('total_volumn_of_margin_transactions')}
                      placeholder={getContentKey('enter_total_volumn_of_margin_transactions')}
                      value={values?.estimateTotalVolumeOfYourInstitutionMarginInThePastFiveYears}
                      maxLength={15}
                      onChange={(text) => {
                        if (numeric_decimal_regix.test(text) || text === '')
                          setFieldValue('estimateTotalVolumeOfYourInstitutionMarginInThePastFiveYears', text)
                      }}
                      isLabelHeight
                      isRequired={false}
                      isRightSymbol
                      className={`w-full md:w-2/5 ${isArabic ? "mx-auto me-0":"mx-auto ms-0"}`}
                      divClasses={'mt-10'}
                      remarksMetadata={
                        !(marginTransactionRejectedField?.remarks?.length > 0) &&
                        (values?.estimateTotalVolumeOfYourInstitutionMarginInThePastFiveYears === clientClasificationData?.estimateTotalVolumeOfYourInstitutionMarginInThePastFiveYears) && {
                          sectionId: 4,
                          key: 'estimateTotalVolumeOfYourInstitutionMarginInThePastFiveYears',
                        }}
                    />
                  )
                }
              </>
            )
          )
        }}
      </Formik>
    </div>
  );
};

export default ClientClassification;
